import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {ButtonBehavior} from './button-behavior.js';
import {Puzzle} from './puzzle.js';
import {TransactionalNames} from '../enums/TransactionalNames.js';
import {Statistics} from './statistics.js';
import {PopupWindowController} from '../ui/panels/popup-window.js';
import {Localization} from '../utils/Localization.js';
import {GameFlowController} from './game-flow-controller.js';
import {waitForCondition, waitForSeconds} from '../classes/coroutines/YieldInstructions.js';
import {Coroutine} from '../classes/coroutines/Coroutine.js';
import {StatNames} from '../enums/StatNames.js';
import {BooleanStore} from './boolean-store.js';
import {BooleanName} from '../enums/BooleanName.js';

export class SpawnPieceButton extends ButtonBehavior {
    static TypeName = 'spawn-piece-button';
    static InheritProperties = true;

    private static _instance: SpawnPieceButton;
    static get instance(): SpawnPieceButton {
        return SpawnPieceButton._instance;
    }

    init() {
        if (SpawnPieceButton._instance) {
            console.error('There can only be one instance of SpawnPieceButton Component');
        }
        SpawnPieceButton._instance = this;
    }

    pieceToSpawn: string = 'Coconut Bomb';
    stat: TransactionalNames = TransactionalNames.BombUpgrade;

    cooldownDecrease1: number = 0;
    cooldownDecrease2: number = 4;
    cooldownDecrease3: number = 6;
    cooldownDecrease4: number = 10;
    cooldownDecrease5: number = 16;

    private _numBombsUsed: number = 0;

    override buttonAction(): void {
        Puzzle.instance.spawner.queuePiece(this.pieceToSpawn);
        this._numBombsUsed++;
    }

    // protected override shouldShowTutorial(): boolean {
    //     return (
    //         Statistics.instance.getLong(StatNames.TutorialGamesPlayed) > 0 &&
    //         !BooleanStore.instance.get(BooleanName.CooldownTutorialPlayed)
    //     );
    // }

    // protected override showTutorial(): void {
    //     this._coroutineManager.addCoroutine(new Coroutine(this._tutorial()));
    // }

    private *_tutorial() {
        yield* waitForCondition(() => Puzzle.instance.gameInProgress);
        yield* waitForSeconds(5);
        GameFlowController.instance.startIngameTutorial();

        const popup = PopupWindowController.instance;
        popup.show(Localization.instance.get('CooldownTutorial'), true, true);

        yield* waitForCondition(() => !popup.isVisible);

        BooleanStore.instance.set(BooleanName.CooldownTutorialPlayed, true);
        GameFlowController.instance.endIngameTutorial();
    }

    protected override setCooldown(): number {
        let upgradeLevel = Statistics.instance.getTransactional(
            TransactionalNames.BombUpgrade
        );
        let cooldown: number;

        switch (upgradeLevel) {
            case 1:
                cooldown = this.turnCooldown - this.cooldownDecrease1;
                break;
            case 2:
                cooldown = this.turnCooldown - this.cooldownDecrease2;
                break;
            case 3:
                cooldown = this.turnCooldown - this.cooldownDecrease3;
                break;
            case 4:
                cooldown = this.turnCooldown - this.cooldownDecrease4;
                break;
            case 5:
                cooldown = this.turnCooldown - this.cooldownDecrease5;
                break;
            default:
                cooldown = this.turnCooldown;
                break;
        }

        // failsafe
        if (cooldown < 1) {
            cooldown = 1;
        }

        return cooldown;
    }
}
